import React, { useState, useEffect } from 'react';
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Checkbox,
    TableBody,
    TablePagination,
    Button,
    Grid,
    MenuItem,
    Select
} from '@material-ui/core';

// Icons
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddCircleIcon from '@material-ui/icons/AddCircle';

import translation from "../../../i18n/i18.json"
import useStyles from "../MasterData.css"
import { Role } from '../../../models/Master/Role';
import { InforDisplyaDuration, MasterDataConstants } from '../../../constants/AppConstants';
import { useDispatch } from 'react-redux';
import AllActions from '../../../actions';
import { MasterDataService } from '../../../services/MasterDataService';
import { ApprovalLevel } from '../../../models/Master/ApprovalLevel';
import RoleAddDialog from './RoleAddDialog';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';

export default function UserManagement() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const initialState: Role = {
        id: 0,
        roleName: "",
        approvalLevel: "",
        isActive: false,
        isSBULevel: false
    }

    const [filterParams, setFilterParams] = useState({
        pageNo: 0,
        rowCount: 0,
        roleOrder: "",
        approvalLevel: ""
    });
    const rowsPerPage = MasterDataConstants.TablerowCount;
    const [tableRowData, setTableRowData] = useState<Role[]>([]);
    const [page, setPage] = React.useState(0);
    const [rowCount, setRowCount] = React.useState(0);
    const [selectedData, setSelectedData] = useState<Role>(initialState);
    const [isTableLoading, setIsTableLoading] = React.useState(false);
    const [isUpdateOpen, setIsUpdateOpen] = useState(false);

    const tableColumnData = [
        { name: translation.master_role_name },
        { name: translation.master_role_approval_level },
        { name: translation.master_role_is_sbu_level },
    ];

    const roleOrderList = [
        { code: "asc", name: "Ascending" },
        { code: "dsc", name: "Descending" },
    ];

    const approvalLevelsList: ApprovalLevel[] = [
        { id: 1, name: "All" },
    ]

    useEffect(() => {
        setPage(0);
        setIsTableLoading(true);
    }, []);

    useEffect(() => {
        if (isTableLoading) {
            getRolesList();
        }
    }, [isTableLoading])

    const prepareForRequest = () => {
        dispatch(AllActions.backDropActions.openBackDrop());
    };

    const compeleteRequest = (success: boolean, message?: string) => {
        dispatch(AllActions.backDropActions.closeBackDrop());
        if (message) {
            if (success) {
                dispatch(AllActions.infoActions.openInforSuccess(message, InforDisplyaDuration.common));
            } else {
                dispatch(AllActions.infoActions.openInforError(message, InforDisplyaDuration.common));
            }
        }
    };

    const getRolesList = () => {
        let data: Role[] = [
            {
                id: 1,
                roleName: "A",
                approvalLevel: "String",
                isSBULevel: true,
                isActive: true
            }, {
                id: 2,
                roleName: "B",
                approvalLevel: "String",
                isSBULevel: true,
                isActive: true
            }, {
                id: 2,
                roleName: "C",
                approvalLevel: "String",
                isSBULevel: false,
                isActive: true
            },
        ]

        prepareForRequest();
        MasterDataService.getRoleList(
            filterParams,
            function (roles: Array<Role>) {
                // setTableRowData(roles);
                setTableRowData(data);
                compeleteRequest(true);
                setIsTableLoading(false);
            },
            function (error: Error) {
                // setTableRowData([]);
                setTableRowData(data);
                compeleteRequest(false, translation.master_user_list_error);
                setIsTableLoading(false);
            }
        );
    };

    const onEditClick = (row: Role) => {
        setSelectedData(row);
        setIsUpdateOpen(true);
    }

    const onDeleteClick = (row: Role) => {
        dispatch(AllActions.alertDialogActions.openAlertDialog(
            translation.master_delete_con_title,
            translation.master_delete_con_msg,
            translation.master_delete_con_yesbtn,
            function () {
                setSelectedData(row);
                prepareForRequest();
                MasterDataService.deleteRole(row,
                    function (role: Role) {
                        compeleteRequest(true, translation.master_user_dialog_delete_suc);
                        dispatch(AllActions.alertDialogActions.closeAlertDialog());
                    },
                    function (error: Error) {
                        compeleteRequest(false, translation.master_user_delete_err);
                    });
            },
            translation.master_delete_con_nobtn,
            function () {
                dispatch(AllActions.alertDialogActions.closeAlertDialog());
            }
        ));
    }

    const handleAddRole = () => {
        setSelectedData(initialState);
        setIsUpdateOpen(true);
    }

    const handleUpdateDialogClose = () => {
        setIsUpdateOpen(false);
    }

    const handleFilter = (e: any) => {
        setFilterParams({ ...filterParams, pageNo: 0 });
        setPage(0);
        setIsTableLoading(true);
    }

    const handleChange = (input: string) => (e: any) => {
        let val: any = e.target.value;
        console.log('x', val)
        setFilterParams({ ...filterParams!, [input]: val });
    }

    const handleChangePage = (event: any, newPage: number) => {
        // setFilterParams({...filterParams, "pageNo":(newPage+1)});
        setPage(newPage);
        // setIsTableLoading(true);
    };

    return (
        <React.Fragment>
            {/* Add Role Popup */}
            <RoleAddDialog
                open={isUpdateOpen}
                dataObj={selectedData}
                setDataObj={setSelectedData}
                handleClose={handleUpdateDialogClose} />

            {/* Add Role Btn */}
            <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                <div className={classes.addNewBtnWrapper}>
                    <Button onClick={handleAddRole} style={{ float: "right" }}>
                        <AddCircleIcon></AddCircleIcon>{translation.master_table_role_addbtntxt}</Button>
                </div>
            </Grid>
            {/* FILTERS */}
            <Grid
                container
                spacing={2}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className={classes.filterheader}
            >
            <Grid
                container
                spacing={2}
                item
                xs={12}
                sm={12}
                md={1}
                lg={1}
                className={classes.filterheader}
            >
                Filter
            </Grid>
            <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>
                <div className={classes.filterWrapper}>
                    <div className={classes.dataBlock}>
                        <label className={classes.filterLbl}>{translation.master_rolefilter_roleorder}</label>
                        <div className={classes.inputWrapperFilter}>
                            <Select
                                variant="outlined"
                                value={filterParams.roleOrder || ""}
                                onChange={handleChange("roleOrder")}
                            >
                                {roleOrderList.map((obj) => (
                                    <MenuItem key={obj.code} value={obj.code}>
                                        {obj.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <div className={classes.dataBlock}>
                        <label className={classes.filterLbl}>{translation.master_rolefilter_approval_level}</label>
                        <div className={classes.inputWrapperFilter}>
                            <Select
                                variant="outlined"
                                value={filterParams.approvalLevel || ""}
                                onChange={handleChange("approvalLevel")}
                            >
                                {approvalLevelsList.map((obj, index) => (
                                    <MenuItem key={obj.id} value={obj.id}>
                                        {obj.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <div className={classes.dataBlock}>
                        <div className={classes.searchBtnWrapper}>
                            <Button onClick={handleFilter} style={{ float: "left" }}>
                                <SearchIcon>
                                </SearchIcon>{translation.dashboard_filternm_btntxt}
                            </Button>
                        </div>
                    </div>
                </div>
            </Grid>
            </Grid>
            {/* TABLE COMPONENT */}
            <div className={classes.tblOuterBG}>
                <TableContainer className={classes.tblContainer}>
                    <Table size="small" stickyHeader aria-label="sticky table">
                        <TableHead className={classes.tblHeader}>
                            <TableRow>
                                <TableCell>
                                    <Checkbox></Checkbox>
                                </TableCell>
                                {
                                    tableColumnData && tableColumnData.map((column, index) => {
                                        return <TableCell>{column.name}</TableCell>;
                                    })
                                }
                                <TableCell align="center" style={{ width: "165px" }}>
                                    {translation.master_table_actions}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className={classes.tblBody}>
                            {
                                tableRowData && tableRowData.map((row, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell>
                                                <Checkbox></Checkbox>
                                            </TableCell>
                                            <TableCell>{row.roleName}</TableCell>
                                            <TableCell>{row.approvalLevel}</TableCell>
                                            <TableCell>{row.isSBULevel ? 'Yes' : 'No'}</TableCell>
                                            <TableCell align="center">
                                                <div className={classes.editBtn}>
                                                    <button onClick={(e) => onEditClick(row)}>
                                                        <EditIcon></EditIcon>
                                                        <span className={classes.editBtnTxt}>
                                                            {translation.master_table_editbtntxt}
                                                        </span>
                                                    </button>
                                                </div>
                                                <div className={classes.rejectBtn}>
                                                    <button onClick={(e) => onDeleteClick(row)}>
                                                        <HighlightOffOutlinedIcon></HighlightOffOutlinedIcon>
                                                        <span className={classes.rejectBtnTxt}>{translation.master_table_deletebtntxt}</span>
                                                    </button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={rowCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}>
                </TablePagination>
            </div>
        </React.Fragment>
    )
}